// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const basculin_blue_striped: PokeData = {
  "id": 10016,
  "name": "basculin-blue-striped",
  "height": 10,
  "weight": 180,
  "base_experience": 161,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "tail-whip",
    "bite",
    "water-gun",
    "flail",
    "scary-face",
    "crunch",
    "uproar",
    "aqua-tail",
    "aqua-jet",
    "head-smash",
    "soak",
    "chip-away",
    "final-gambit",
    "wave-crash"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "scary-face",
    "crunch",
    "aqua-tail",
    "aqua-jet",
    "liquidation",
    "water-spout",
    "aqua-cutter",
    "whirlpool",
    "hydro-pump",
    "bubble-beam"
  ],
  "evolution_chain": {
    "id": 280,
    "item": null,
    "species": [
      {
        "name": "basculin",
        "order": 551,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "basculegion",
        "order": 902,
        "types": [
          PokeType.WATER,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 550,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.RECOIL_DAMAGE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 154,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
